import { Conversation } from '@twilio/conversations'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { getConversationDisplayName } from '../helpers'

type ReturnType = {
  displayName: string
  isLoading: boolean
}

const useConversationDisplayName = (conversation: Conversation): ReturnType => {
  const [displayName, setDisplayName] = useState('')
  const [isLoading, setIsLoading] = useState(true)

  const { users } = useSelector((state: MStore.RootState) => state.resources)
  const { userInfo: currentUser } = useSelector((state: MStore.RootState) => state.users)

  useEffect(() => {
    ;(async () => {
      if (conversation.friendlyName) {
        setDisplayName(conversation.friendlyName)
        setIsLoading(false)
        return
      }
      const response = await getConversationDisplayName(conversation, users, currentUser?._id)
      if (response) {
        setDisplayName(response)
      }
      setIsLoading(false)
    })()
  }, [users, conversation, setDisplayName, setIsLoading, currentUser?._id, conversation.friendlyName])

  return {
    displayName,
    isLoading
  }
}

export { useConversationDisplayName }
